import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { canUseDOM, get } from '../../utils';
export var ANNUAL_FEE = 'universityPrograms.programs.annualFeeRange';
export var splitter = ';,;';
export var addQueryString = function addQueryString(facetsName, value, history) {
  if (canUseDOM) {
    var url = new URL(window.location.href);
    url.searchParams.set(facetsName, "".concat(value));
    history.replace("".concat(history.location.pathname).concat(url.search).concat(url.hash));
  }
};
export var deleteQueryString = function deleteQueryString(facetsName, history) {
  if (canUseDOM) {
    var url = new URL(window.location.href);
    url.searchParams.delete(facetsName);

    // @ts-ignore
    if (_toConsumableArray(url.searchParams.keys()).length) {
      history.push("".concat(url.search).concat(url.hash));
    } else {
      history.push(window.location.pathname);
    }
  }
};
export var addQueryStringMultiple = function addQueryStringMultiple(facetsName, values, history) {
  var withoutSavingPrevValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (canUseDOM) {
    var url = new URL(window.location.href);
    var current = url.searchParams.get(facetsName) || '';
    var newQuery = '';
    var newQueryArr = [];
    if (!withoutSavingPrevValues) {
      // save values from others filters
      current.split(splitter).forEach(function (v) {
        var val = v.trim();
        if (val && typeof values[val] === 'undefined') {
          newQueryArr.push(val);
        }
      });
    }
    if (values.length) {
      values.forEach(function (key) {
        return newQueryArr.push(key);
      });
    } else {
      Object.keys(values).forEach(function (key) {
        if (values[key]) {
          newQueryArr.push(key);
        }
      });
    }
    url.searchParams.set(facetsName, newQueryArr.join(splitter));
    history.push("".concat(url.search).concat(url.hash));
  }
};
export var removeQuerySortingString = function removeQuerySortingString(facetsNames, history) {
  var searchIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (canUseDOM) {
    var url = new URL(window.location.href);
    facetsNames.forEach(function (facetsName) {
      url.searchParams.delete("".concat(searchIndex, "_asc_").concat(facetsName));
    });

    // @ts-ignore
    if (_toConsumableArray(url.searchParams.keys()).length) {
      history.push("".concat(url.search).concat(url.hash));
    } else {
      history.push(window.location.pathname);
    }
  }
};
export var addQuerySorting = function addQuerySorting(facetsNames, values, history) {
  var searchIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (canUseDOM) {
    var url = new URL(window.location.href);
    facetsNames.forEach(function (facetsName) {
      url.searchParams.delete("".concat(searchIndex, "_asc_").concat(facetsName));
    });
    var entriesValues = Object.entries(values).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        v = _ref2[1];
      return v;
    });
    if (entriesValues.length) {
      entriesValues.forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          key = _ref4[0];
        url.searchParams.set("".concat(searchIndex, "_asc_").concat(key), '');
      });
      history.push("".concat(url.search).concat(url.hash));
    }
  }
};
export var removeQueryString = function removeQueryString(facetsName, history) {
  if (canUseDOM) {
    var url = new URL(window.location.href);
    url.searchParams.delete(facetsName);
    history.push("".concat(url.pathname).concat(url.search));
  }
};
export var totalParams = function totalParams() {
  if (canUseDOM) {
    var url = new URL(window.location.href);
    return Array.from(url.searchParams).length;
  }
  return 0;
};
export var getAlgoliaTagsList = function getAlgoliaTagsList(filters) {
  var output = filters && filters.values && filters.values.filter(function (i) {
    return i.fieldNameItem;
  }).map(function (item) {
    return get(item, 'fieldNameItem.item.fieldName.value') || get(item, 'fieldNameItem.item.dateFromFieldName.value');
  });
  filters && filters.values && filters.values.filter(function (i) {
    return i.fieldNameItems;
  }).forEach(function (item) {
    if (get(item, 'fieldNameItems.items.0.fieldName.value', '') === 'venue.rooms.typeRoom') {
      output.push(get(item, 'fieldNameItems.items.0.fieldName.value', ''));
    } else {
      get(item, 'fieldNameItems.items', []).forEach(function (item) {
        if (get(item, 'fieldName.value', '')) {
          output.push(get(item, 'fieldName.value', ''));
        }
      });
    }
  });
  return output;
};
export var convertQueryParamsToFacets = function convertQueryParamsToFacets(queryString) {
  var returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var filters = arguments.length > 2 ? arguments[2] : undefined;
  var facets = [];
  var tags = getAlgoliaTagsList(filters);
  Object.keys(queryString).map(function (item) {
    if (tags.indexOf(item) > -1 || item.indexOf('curators') > -1) {
      if (item !== 'eventDatesRange' && item !== ANNUAL_FEE && item !== 'valid' && item !== "totalHotelRooms") {
        var queryValue = queryString[item];
        item = item === 'maxDelegates' ? 'maxDelegatesRangeIndex' : item;
        facets.push(queryValue.split(splitter).map(function (query) {
          if (!parseInt(query)) {
            if (returnType) return "".concat(item, ":").concat(query.split('+').join(' '));else return "".concat(query.split('+').join(' '));
          } else {
            if (query.indexOf('+') > -1) {
              query = query.split('+').join(' ');
            }
            if (returnType) return "".concat(item, ":").concat(query);else return "".concat(query);
          }
        }));
      }
    }
  });
  return facets;
};
export var convertQueryParamsToFacetsWithoutPlusReplacement = function convertQueryParamsToFacetsWithoutPlusReplacement(queryString) {
  var returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var filters = arguments.length > 2 ? arguments[2] : undefined;
  var facets = [];
  var tags = getAlgoliaTagsList(filters);
  Object.keys(queryString).map(function (item) {
    if (tags.indexOf(item) > -1 || item.indexOf('curators') > -1) {
      if (item !== 'eventDatesRange' && item !== ANNUAL_FEE && item !== 'valid' && item !== "totalHotelRooms") {
        var queryValue = queryString[item];
        item = item === 'maxDelegates' ? 'maxDelegatesRangeIndex' : item;
        facets.push(queryValue.split(splitter).map(function (query) {
          if (returnType) return "".concat(item, ":").concat(query);else return "".concat(query);
        }));
      }
    }
  });
  return facets;
};
export var generateFacetForRequest = function generateFacetForRequest(selectedFilters, filters) {
  var excludeTags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var facets = [];
  var tags = getAlgoliaTagsList(filters);
  Object.keys(selectedFilters).forEach(function (item) {
    if (tags.includes(item)) {
      if (item !== 'eventDatesRange' && item !== ANNUAL_FEE && item !== 'valid' && item !== "totalHotelRooms" && !excludeTags.includes(item)) {
        if (selectedFilters[item].length) {
          facets.push(selectedFilters[item].map(function (value) {
            return "".concat(item, ":").concat(value);
          }));
        }
      }
    }
  });
  return facets;
};
export default addQueryString;